
import programSessionMixin from "@/mixins/programSession.mixin"

export default {
  mixins: [programSessionMixin],

  props: {
    activeGroup: { type: [Boolean, Object], default: () => {} },
    session: { type: Object, default: () => {} },
  },

  data: () => ({
    isOverflow: false,
    scrollHeight: 0,
    companies: "",
  }),

  mounted () {
    if (this.activeGroup) {
      const { card } = this.$refs
      if (card) {
        const { offsetHeight, scrollHeight } = card.$el
        this.isOverflow = offsetHeight < scrollHeight
        this.scrollHeight = scrollHeight
      }
    }

    this.fetchCompanies()
  },

  methods: {
    onClick () {
      const { activeGroup, session } = this
      if (!activeGroup) return
      this.$nuxt.$emit("open-session", session)
    },

    async fetchCompanies () {
      const [res, err] = await this.$api.program.getParticipants({
        params: {
          "filter[session]": this.session.alias,
          "sort[lastName]": "asc",
        },
      })
      if (err) return console.error(err)
      let companies = this.$api.helpers.getList(res)
        .map(p => this.$fmt.localize(p.person.company))
        .filter(Boolean)
      companies = [...new Set(companies)]
      this.companies = companies.join(", ")
    },
  },
}
